import React, { useRef, useState } from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import { useTextOverflow } from './useTextOverflow';

export interface ParticipantCommentProps {
  comment?: string | null;
}

export type ParticipantCommentComponent = React.FC<ParticipantCommentProps>;

const ParticipantComment: ParticipantCommentComponent = ({ comment }) => {
  const { t } = useTranslation('training');
  const [commentExpanded, setCommentExpanded] = useState(false);
  const commentTextRef = useRef<HTMLParagraphElement>(null);
  const commentTrimmed = comment?.trim() ?? '';

  const commentOverflows = useTextOverflow(
    commentTextRef,
    commentTrimmed,
    commentExpanded
  );

  if (!commentTrimmed) {
    return null;
  }

  return (
    <>
      <div className={classes['trainee-comment-box']}>
        <Icon name="comment" className={classes['trainee-comment-icon']} />
        <p
          ref={commentTextRef}
          className={`${classes['trainee-comment-text']} ${commentExpanded ? classes['expanded'] : ''}`}
        >
          {commentTrimmed}
        </p>
      </div>
      {(commentOverflows || commentExpanded) && (
        <button
          type="button"
          className={classes['trainee-comment-toggle']}
          onClick={() => setCommentExpanded((prev) => !prev)}
        >
          {commentExpanded ? t('participantCommentShowLess') : t('participantCommentShowMore')}
        </button>
      )}
    </>
  );
};

export default ParticipantComment;
